// extracted by mini-css-extract-plugin
module.exports = {"container":"popup_container__7bQsX","button":"popup_button__AX44j","message":"popup_message__6_n6g"};